import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import DeepDive from 'models/Tools/DeepDive';
import { axiosBaseQuery } from 'services/api';

export const DEEP_DIVE_TAG = 'DeepDive';

export const deepDiveApi = createApi({
  reducerPath: 'deepDiveApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/deep-dive-materials/',
  }),
  tagTypes: [DEEP_DIVE_TAG],
  endpoints: builder => ({
    // Fetch a single deep dive
    fetchDeepDive: builder.query({
      query: id => ({ url: `${id}/` }),
    }),

    // Get list of deep dive materials
    getDeepDives: builder.query({
      query: params => ({
        method: 'GET',
        params,
      }),
      transformResponse: ({ count, results }) => ({
        count,
        results: List(results.map(item => new DeepDive(item))),
      }),
      providesTags: [DEEP_DIVE_TAG],
    }),

    // Create deep dive material
    createDeepDive: builder.mutation({
      query: data => ({
        method: 'POST',
        data,
      }),
      invalidatesTags: [DEEP_DIVE_TAG],
    }),

    // Update deep dive material
    updateDeepDive: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [DEEP_DIVE_TAG],
    }),

    // Delete deep dive material
    deleteDeepDive: builder.mutation({
      query: id => ({
        url: `${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [DEEP_DIVE_TAG],
    }),
  }),
});

export const {
  useFetchDeepDiveQuery,
  useGetDeepDivesQuery,
  useCreateDeepDiveMutation,
  useUpdateDeepDiveMutation,
  useDeleteDeepDiveMutation,
} = deepDiveApi;
